import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Space,
  Breadcrumb,
  Tabs,
  Avatar,
  Typography,
  Drawer,
} from "antd";
import {
  DoubleRightOutlined,
  MailOutlined,
  PhoneOutlined,
  SwapOutlined,
  EditOutlined,
  HomeOutlined,
  MoneyCollectOutlined,
} from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileContract,
  faScrewdriverWrench,
  faUserTie,
  faFileInvoice,
} from "@fortawesome/free-solid-svg-icons";
import AddPartnerClient from "./AddPartnerClient";
import { useSelector, useDispatch } from "react-redux";
import { GetPartnerClientByIdApi } from "../ClientsApi";
import { FormattedMessage, useIntl } from "react-intl";
import { Link, useNavigate, useParams } from "react-router-dom";
import logoicon from "../../../logoicon.png";
import gold from "../../../gold.png";
import silver from "../../../silver.png";
import bronze from "../../../bronze.png";
import Estimates from "../Quotes/Estimates";
import WorkOrders from "../WorkOrders/WorkOrders";
import ProductsInfo from "../Components/ProductsInfo";
import ClientsList from "../Components/ClientsList";
import InvoicesList from "features/Invoices/Components/InvoicesList";
import CompanyEnum from "features/Enums/CompanyEnum";
function PartnerClientDetails() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { Title, Text } = Typography;
  const [activeTab, setActiveTab] = useState("1");
  const { partnerId } = useParams();
  const partnerDet = useSelector((state) => state?.clients?.partnerClientById);
  const addressProvinces = useSelector(
    (state) => state.lookup.addressProvinces
  );
  const addressCountries = useSelector(
    (state) => state.lookup.addressCountries
  );
  const [visibleCard, setVisibleCard] = useState("card1");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const companyId = localStorage.getItem("CompanyId");
  const handleTabChange = (key) => {
    if (String(key) === "5") {
      dispatch(GetPartnerClientByIdApi(partnerId));
    }
    setActiveTab(key);
  };
  const handleEdit = (partnerId) => {
    // navigate(`/editclient/${id}`);
    setIsDrawerOpen(true);
  };
  // const handleAddClient = () => {
  //   navigate("/addclient");
  // };
  useEffect(() => {
    if (partnerId) {
      dispatch(GetPartnerClientByIdApi(partnerId));
    }
  }, [partnerId, dispatch]);
  const getFormattedAddresses = (isBilling) =>
    partnerDet?.address
      ?.filter((addr) => addr.isBilling === isBilling)
      .map((addr, index) => {
        const { address1, address2, city, provinceId, zip, countryId } = addr;

        const fullAddress = [
          address1,
          address2,
          city,
          addressProvinces.find((p) => p.id === provinceId)?.provinceNameEn,
          zip,
          addressCountries.find((c) => c.id === countryId)?.countryNameEn,
        ]
          .filter(Boolean)
          .join(", ");

        return <div key={index}>{fullAddress}</div>;
      });

  const getAvatarImageByTypeId = (typeId) => {
    switch (typeId) {
      case 1:
        return gold;
      case 2:
        return silver;
      case 3:
        return bronze;
      default:
        return bronze;
    }
  };

  const getCompanyNamesFromMapping = (mappings = []) => {
    const companyNames = mappings
      .map((entry) => {
        const company = Object.values(CompanyEnum).find(
          (c) => c.id === entry.companyId
        );
        return company?.name;
      })
      .filter(Boolean);

    return companyNames.join(", ");
  };

  return (
    <>
      <div className="medispamain" style={{ position: "relative" }}>
        <div className="main-area">
          <div className="title-part detailsposition">
            <Row align="middle" justify="space-between">
              <Col>
                <h4>
                  <FormattedMessage id="PartnerClient.PartnerClientDetails" />
                </h4>
              </Col>

              <Col className="text-right detailsbtns">
                <Space>
                  <Breadcrumb
                    separator={<DoubleRightOutlined />}
                    items={[
                      {
                        title: <FormattedMessage id="PartnerCLient.Partners" />,
                        href: `/${companyId}/partner`,
                      },
                      {
                        title: (
                          <FormattedMessage id="PartnerClient.PartnerClientDetails" />
                        ),
                      },
                    ]}
                  />
                </Space>
              </Col>
            </Row>
          </div>
          <div style={{ width: "100%" }} className="dashboard">
            {visibleCard === "card1" && (
              <Card
                title={<FormattedMessage id="PartnerClient.PartnerOverview" />}
                extra={
                  <>
                    <Space>
                      <Button
                        variant="outline"
                        onClick={() => handleEdit(handleEdit)}
                      >
                        <EditOutlined />
                        <FormattedMessage id="PartnerCLient.EditPartner" />
                      </Button>
                      <DoubleRightOutlined
                        onClick={() => setVisibleCard("card2")}
                        style={{
                          cursor: "pointer",
                          color: "#fff",
                          transform: "rotate(90deg)",
                        }}
                      />
                    </Space>
                  </>
                }
              >
                <Row gutter={[16, 16]}>
                  {/* Left Section */}
                  <Col xs={24} sm={10} lg={6} style={{ textAlign: "center" }}>
                    <Avatar
                      style={{
                        backgroundColor: "#fff",
                        verticalAlign: "middle",
                        width: 68,
                        height: 60,
                        fontSize: 18,
                      }}
                    >
                      <img
                        src={getAvatarImageByTypeId(partnerDet?.typeId)}
                        className="member-img-top"
                        alt={String(partnerDet?.typeId)}
                      />
                    </Avatar>

                    <Title level={4} style={{ marginBottom: 0 }}>
                      {partnerDet?.companyName}
                    </Title>

                    <p>
                      <PhoneOutlined style={{ marginRight: 8 }} />
                      {partnerDet?.countryCode}&nbsp;
                      {partnerDet?.phone?.length === 10
                        ? partnerDet?.phone?.replace(
                            /(\d{3})(\d{3})(\d{4})/,
                            "$1-$2-$3"
                          )
                        : partnerDet?.phone}
                    </p>
                    <p>
                      <MailOutlined style={{ marginRight: 8 }} />
                      {partnerDet?.email}
                    </p>

                    <div style={{ marginTop: 12 }}>
                      <Text className="text-type1">
                        <MoneyCollectOutlined />{" "}
                        <FormattedMessage id="PartnerClient.CreditLimit" />
                      </Text>
                      <br />
                      <Text className="text-type2">
                        {partnerDet?.creditLimit != null
                          ? `$ ${Number(
                              partnerDet.creditLimit
                            ).toLocaleString()}`
                          : "$0"}
                      </Text>
                    </div>

                    <div style={{ marginTop: 12 }}>
                      <Button type="primary" variant="solid">
                        <FormattedMessage id="PartnerClient.MasterServiceAgreement" />
                      </Button>
                    </div>
                  </Col>

                  {/* Right Section */}
                  <Col xs={24} sm={14} lg={18}>
                    <Title level={5} style={{ color: "rgb(58, 88, 146)" }}>
                      <FormattedMessage id="PartnerClient.BillingInfo" />
                    </Title>

                    {/* 🧾 Billing Information */}
                    <Row gutter={[16, 16]}>
                      <Col xs={24} sm={12} md={12} lg={8}>
                        <Text className="text-type1">
                          <FormattedMessage id="PartnerClient.Name" />
                        </Text>
                        <br />
                        <Text className="text-type2">
                          {partnerDet?.billingContactPerson}
                        </Text>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={8}>
                        <Text className="text-type1">
                          <FormattedMessage id="PartnerClient.Email" />
                        </Text>
                        <br />
                        <Text className="text-type2">
                          {partnerDet?.billingEmail}
                        </Text>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={8}>
                        <Text className="text-type1">
                          <FormattedMessage id="PartnerClient.PhoneNumber" />
                        </Text>
                        <br />
                        <Text className="text-type2">
                          {`${partnerDet?.billingCountryCode || ""} ${
                            /^\d{10}$/.test(partnerDet?.phone)
                              ? partnerDet.phone.replace(
                                  /(\d{3})(\d{3})(\d{4})/,
                                  "$1-$2-$3"
                                )
                              : partnerDet?.phone || ""
                          }`}
                        </Text>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={8}>
                        <Text className="text-type1">
                          <FormattedMessage id="PartnerClient.BillingAddress" />
                        </Text>
                        <br />
                        <Text className="text-type2">
                          {getFormattedAddresses(true)}
                        </Text>
                      </Col>
                    </Row>

                    {/* 🚚 Main Information */}
                    <div style={{ marginTop: 10 }}>
                      <Title level={5} style={{ color: "rgb(58, 88, 146)" }}>
                        <FormattedMessage id="PartnerClient.MainInformation" />
                      </Title>

                      <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12} md={12} lg={8}>
                          <Text className="text-type1">
                            <FormattedMessage id="PartnerClient.Name" />
                          </Text>
                          <br />
                          <Text className="text-type2">
                            {partnerDet?.contactPerson}
                          </Text>
                        </Col>

                        <Col xs={24} sm={12} md={12} lg={8}>
                          <Text className="text-type1">
                            <FormattedMessage id="PartnerClient.Email" />
                          </Text>
                          <br />
                          <Text className="text-type2">
                            {partnerDet?.email}
                          </Text>
                        </Col>

                        <Col xs={24} sm={12} md={12} lg={8}>
                          <Text className="text-type1">
                            <FormattedMessage id="PartnerClient.PhoneNumber" />
                          </Text>
                          <br />
                          <Text className="text-type2">
                            {`${partnerDet?.countryCode || ""} ${
                              /^\d{10}$/.test(partnerDet?.phone)
                                ? partnerDet.phone.replace(
                                    /(\d{3})(\d{3})(\d{4})/,
                                    "$1-$2-$3"
                                  )
                                : partnerDet?.phone || ""
                            }`}
                          </Text>
                        </Col>

                        <Col xs={24} sm={12} md={12} lg={8}>
                          <Text className="text-type1">
                            <FormattedMessage id="PartnerClient.ShippingAddress" />
                          </Text>
                          <br />
                          <Text className="text-type2">
                            {getFormattedAddresses(false)}
                          </Text>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Card>
            )}

            {visibleCard === "card2" && (
              <Card
                title="Partner Overview"
                extra={
                  <>
                    <Space>
                      <Button
                        variant="outline"
                        onClick={() => handleEdit(partnerDet?.id)}
                      >
                        <EditOutlined />
                        <FormattedMessage id="PartnerCLient.EditPartner" />
                      </Button>
                      <DoubleRightOutlined
                        onClick={() => setVisibleCard("card1")}
                        style={{
                          cursor: "pointer",
                          color: "#fff",
                          transform: "rotate(90deg)",
                        }}
                      />
                    </Space>
                  </>
                }
              >
                <Row align="middle" justify="end">
                  <Col xs={24} sm={16}>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "flex-start",
                        gap: 12,
                      }}
                    >
                      <div style={{ width: 48 }}>
                        <Avatar
                          style={{
                            backgroundColor: "#3a5892",
                            verticalAlign: "middle",
                            width: 48,
                            height: 48,
                            fontSize: 18,
                          }}
                        >
                          {partnerDet?.companyName?.charAt(0).toUpperCase()}
                        </Avatar>
                      </div>

                      <div style={{ flex: 1 }} className="leadtop">
                        <h4
                          className="word-break"
                          style={{ fontWeight: "bold", marginBottom: 0 }}
                        >
                          {partnerDet?.companyName}
                          <img
                            src={getAvatarImageByTypeId(partnerDet?.typeId)}
                            className="member-img"
                            alt={String(partnerDet?.typeId)}
                          />
                        </h4>
                        <Space>
                          <p>
                            <PhoneOutlined style={{ marginRight: 8 }} />
                            {partnerDet?.countryCode}&nbsp;
                            {partnerDet?.phone} &nbsp;&nbsp;|
                          </p>
                          <p>
                            <MailOutlined style={{ marginRight: 8 }} />
                            {partnerDet?.email}
                          </p>
                        </Space>
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={8} align="end" className="sm-md-10">
                    <Space>
                      <h3>
                        <img
                          src={logoicon}
                          style={{
                            width: "24px",
                            marginRight: 3,
                            position: "relative",
                            top: "2px",
                          }}
                          alt=""
                        />
                        {getCompanyNamesFromMapping(
                          partnerDet?.partnerClientCompanyMapping
                        )}
                      </h3>
                      {/* <Button
                        type="primary"
                        variant="solid"
                        onClick={() => handleEdit(partnerDet?.id)}
                      >
                        <EditOutlined />
                        <FormattedMessage id="ClientDetails.EditClient" />
                      </Button> */}
                    </Space>
                  </Col>
                </Row>
              </Card>
            )}
          </div>

          <Row gutter={16} className="mt-10">
            {/* <Col span={6}>
              <PartnerClientInfo />
            </Col>  */}
            <Col span={24} className="navtabs-new">
              <Tabs defaultActiveKey="1" centered onChange={handleTabChange}>
                <Tabs.Item
                  tab={
                    <span>
                      <FontAwesomeIcon icon={faUserTie} />
                      &nbsp;Clients
                    </span>
                  }
                  key="1"
                >
                  {activeTab === "1" && (
                    <ClientsList id={partnerId} screen={"clients"} />
                  )}
                </Tabs.Item>
                <Tabs.Item
                  tab={
                    <span>
                      <FontAwesomeIcon icon={faFileInvoice} />
                      &nbsp; <FormattedMessage id="Dashboard.Quotes" />
                    </span>
                  }
                  key="2"
                >
                  {activeTab === "2" && <Estimates />}
                </Tabs.Item>
                <Tabs.Item
                  tab={
                    <span>
                      <FontAwesomeIcon icon={faFileContract} />
                      &nbsp;
                      <FormattedMessage id="ClientDetails.WorkOrders" />
                    </span>
                  }
                  key="3"
                >
                  {activeTab === "3" && <WorkOrders />}
                </Tabs.Item>
                <Tabs.Item
                  tab={
                    <span>
                      <FontAwesomeIcon icon={faScrewdriverWrench} />
                      &nbsp; Products
                    </span>
                  }
                  key="4"
                >
                  {activeTab === "4" && <ProductsInfo />}
                </Tabs.Item>
                <Tabs.Item
                  tab={
                    <span>
                      <FontAwesomeIcon icon={faFileInvoice} />
                      &nbsp;
                      <FormattedMessage id="Invoice.Heading" />
                    </span>
                  }
                  key="5"
                >
                  {activeTab === "5" && (
                    <InvoicesList
                      partnerClientId={partnerId}
                      CreateInvoiceVisible={false}
                    />
                  )}
                </Tabs.Item>
              </Tabs>
            </Col>
          </Row>
        </div>
      </div>
      <Drawer
        title={<FormattedMessage id="PartnerCLient.EditPartner" />}
        width={600}
        onClose={() => setIsDrawerOpen(false)}
        open={isDrawerOpen}
        destroyOnClose
      >
        <AddPartnerClient
          clientId={partnerId}
          onClose={() => setIsDrawerOpen(false)}
          isValidationRequired={true}
        />
      </Drawer>
    </>
  );
}

export default PartnerClientDetails;
